import { RouteProps } from 'react-router-dom';
import { loginPagesMenu } from '../menu';
import DefaultAside from '../pages/_layout/_asides/DefaultAside';

const asides: RouteProps[] = [
	{ path: loginPagesMenu.login.path, element: null },
	{ path: '*', element: <DefaultAside /> },
];

export default asides;
